
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"openInManagementCenter":"Open attribute in Management Center"},"de":{"openInManagementCenter":"Attribut im Management Center öffnen"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();